import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
const PrivateRoute = ({ element, requiredRole }) => {
  const storeData = useSelector((state) => state.mainReducer);
  const { userData } = storeData;
  // const { isAuthenticated, user } = useAuth();
  // if (!isAuthenticated) {
  //   return <Navigate to="/login" />;
  // }

  if (Array.isArray(requiredRole)) {
    if (userData && !requiredRole.includes(userData?.role || "")) {
      return <Navigate to="/not-found" />; // Redirect if role doesn't match
    }
  } else if (typeof requiredRole === "string") {
    if (userData && userData.role !== requiredRole) {
      return <Navigate to="/not-found" />; // Redirect if role doesn't match
    }
  }
  return element;
};

export default PrivateRoute;
